import styled from 'styled-components';
import { ErrorIcon } from 'ui/components/atoms/Icons';
import { CaptionStrong } from 'ui/components/atoms/LegacyText';
import themeColors from 'ui/styles/config/colors';
import themeSpacing from 'ui/styles/config/spacing';

export const TooltipWrapper = styled.div`
  display: flex;
`;

export const TooltipIcon = styled(ErrorIcon)`
  cursor: pointer;
`;

export const ErrorCaption = styled(CaptionStrong)`
  margin-bottom: ${themeSpacing.xs2};
  color: ${themeColors.errorText01};
`;
